import { Injectable } from '@angular/core';

/*
  This service is responsible for handling specific focus behaviors required
  for accessibility ie. branching and trapping.
  It is used by DipseModal and DipsePopover.

*/
@Injectable()
export class FocusService {
  private next = new Map<HTMLElement, HTMLElement>();
  private nextOf = new Map<HTMLElement, HTMLElement>();
  private trappedIn: HTMLElement = document.body;
  constructor(
  ) {
    window.addEventListener('keydown', event => {
      const activeElement = document.activeElement as HTMLElement;

      if (event.key === 'Tab') {
        event.preventDefault();
        if (event.shiftKey) {
          const previousOfMain = this.previousOfMain(activeElement, this.trappedIn);
          const next = this.next.get(previousOfMain);
          if (next) {
            next.focus();
            return;
          }
          const nextOf = this.nextOf.get(activeElement);
          if (nextOf) {
            nextOf.focus();
            return;
          }
          this.previousOfMain(activeElement, this.trappedIn).focus();

        } else {
          const next = this.next.get(activeElement);
          if (next) {
            next.focus();
            return;
          }
          const nextOf = this.nextOf.get(activeElement);
          if (nextOf) {
            this.nextOfMain(nextOf, this.trappedIn).focus();
            return;
          }
          this.nextOfMain(activeElement, this.trappedIn).focus();
        }
      }
    });
  }
  private nextOfMain(activeElement: HTMLElement, container: HTMLElement) {
    const focusables = this.findFocusableElements(container).filter(focusable => !this.nextOf.get(focusable));
    if (!focusables.length) {
      return document.body;
    }
    const index = focusables.findIndex(focusable => focusable === activeElement);
    if (index < focusables.length - 1) {
      return focusables[index + 1];
    } else {
      return focusables[0];
    }
  }
  private previousOfMain(activeElement: HTMLElement, container: HTMLElement) {
    const focusables = this.findFocusableElements(container).filter(focusable => !this.nextOf.get(focusable));
    if (!focusables.length) {
      return document.body;
    }
    const index = focusables.findIndex(focusable => focusable === activeElement);
    if (index > 0) {
      return focusables[index - 1];
    } else {
      return focusables[focusables.length - 1];
    }
  }
  public findFocusableElements(container = document.body): HTMLElement[] {
    return Array.from(container.querySelectorAll('button:not(:disabled), a:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled)'));
  }
  public registerBranch(triggerElement: HTMLElement, closeButton: HTMLButtonElement) {
    this.next.set(triggerElement, closeButton);
    this.nextOf.set(closeButton, triggerElement);
  }
  public deregisterBranch(triggerElement: HTMLElement) {
    const closeButton = this.next.get(triggerElement);
    this.next.delete(triggerElement);
    this.nextOf.delete(closeButton);
  }
  public trap(container: HTMLElement) {
    this.trappedIn = container;
  }
  public unTrap() {
    this.trappedIn = document.body;
  }
}
